import { GET_PLANNED_REVOCATION } from "../../../enums/Request/request.types";

export const getPlannedRevocationAction = (data) => {
    return {
        type: GET_PLANNED_REVOCATION,
        payload: data,
    };
};
